'use strict';
const $ = require ('./mm-widgets');

$.fn.termsAndConditionsWidget = function (subscriptionModel) {
	return this.each(function () {
		const widget = $(this),
			termsField = widget.find('[data-mm-role~="agreeTandC"]');

		widget.on('show', function () {
			termsField.prop('checked', subscriptionModel.hasAgreedSubscription());
		});
		termsField.click(function () {
			const checked = !!(termsField.prop('checked'));
			subscriptionModel.setAgreedSubscription(checked);
		});
	});
};

